"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var merchant = _interopRequireWildcard(require("@/api/merchant"));
var _creatMerchant = _interopRequireDefault(require("./creatMerchant"));
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
var _user = require("@/api/user");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'MerchantList',
  components: {
    creatMerchant: _creatMerchant.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      fromList: this.$constants.fromList,
      isChecked: false,
      listLoading: false,
      headeNum: [{
        count: '',
        type: '1',
        title: '正常开启的商户'
      }, {
        count: '',
        type: '0',
        title: '已关闭商户'
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        dateLimit: '',
        isSwitch: '1',
        keywords: '',
        isSelf: '',
        categoryId: '',
        typeId: '',
        isFu: '',
        onboardingType: ''
      },
      keywords: '',
      autoUpdate: true,
      timeVal: [],
      merId: 0,
      keyNum: 0,
      isDisabled: false,
      indexKey: 0,
      handleType: '' //操作类型，编辑、详情
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['merchantClassify', 'merchantType'])),
  mounted: function mounted() {
    if (!this.merchantClassify.length) this.$store.dispatch('merchant/getMerchantClassify');
    if (!this.merchantType.length) this.$store.dispatch('merchant/getMerchantType');
    if ((0, _permission.checkPermi)(['platform:merchant:list:header:num'])) this.getHeadNum();
    if ((0, _permission.checkPermi)(['platform:merchant:page:list'])) this.getList('');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //详情中点击编辑按钮
    onChangeEdit: function onChangeEdit() {
      this.isDisabled = !this.isDisabled;
    },
    /**
     *  选择时间
     */
    selectChange: function selectChange(tab) {
      this.tableFrom.dateLimit = tab;
      this.timeVal = [];
      this.tableData.data = [];
      this.getList(1);
      this.getHeadNum();
    },
    /**
     *  具体日期
     */
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = this.timeVal ? this.timeVal.join(',') : '';
      this.getList(1);
      this.getHeadNum();
    },
    /**
     *  获取开启商户数
     */
    getHeadNum: function getHeadNum() {
      var _this2 = this;
      var data = _objectSpread({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.isSwitch;
      merchant.merHeaderNumApi(data).then(function (res) {
        _this2.headeNum[0]['count'] = res.openNum;
        _this2.headeNum[1]['count'] = res.closeNum;
      }).catch(function (res) {});
    },
    /**
     *  列表
     */
    getList: function getList(num) {
      var _this3 = this;
      this.listLoading = true;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      this.tableFrom.page = num ? num : this.tableFrom.page;
      merchant.merchantListApi({
        page: this.tableFrom.page,
        limit: this.tableFrom.limit,
        dateLimit: this.tableFrom.dateLimit,
        isSwitch: this.tableFrom.isSwitch,
        keywords: this.tableFrom.keywords,
        isSelf: this.tableFrom.isSelf,
        categoryId: this.tableFrom.categoryId,
        typeId: this.tableFrom.typeId,
        isFu: this.tableFrom.isFu,
        onboardingType: this.tableFrom.onboardingType
      }).then(function (res) {
        _this3.tableData.data = res.list;
        _this3.tableData.total = res.total;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
        _this3.$message.error(res.message);
      });
    },
    reset: function reset() {
      this.timeVal = [];
      this.tableFrom.dateLimit = '';
      this.tableFrom.isSelf = '';
      this.tableFrom.categoryId = '';
      this.tableFrom.typeId = '';
      this.tableFrom.isFu = '';
      this.tableFrom.onboardingType = '';
      this.tableFrom.keywords = '';
      this.keywords = '';
      this.getHeadNum();
      this.getList(1);
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
      this.getHeadNum();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList(1);
      this.getHeadNum();
    },
    /**
     *  修改状态
     */
    onchangeIsShow: function onchangeIsShow(row) {
      var _this4 = this;
      if (this.tableFrom.isSwitch === '0') return;
      row.isRecommend = !row.isRecommend;
      var title = !row.isRecommend ? '是否开启推荐商户' : '是否关闭推荐商户';
      this.$modalSure(title).then(function () {
        merchant.merchantSwitchApi(row.id).then(function (res) {
          row.isRecommend = !row.isRecommend;
          _this4.$message.success('切换商户推荐开关成功');
        });
      });
    },
    onchangeShowLockFu: function onchangeShowLockFu(row) {
      var _this5 = this;
      if (this.tableFrom.isSwitch === '0') return;
      row.showLockFu = !row.showLockFu;
      var title = !row.showLockFu ? '是否开启锁定福豆字段显示' : '是否关闭锁定福豆字段显示';
      this.$modalSure(title).then(function () {
        merchant.merchantShowLockFuSwitchApi(row.id).then(function () {
          row.showLockFu = !row.showLockFu;
          _this5.$message.success('切换锁定福豆显示开关成功');
          _this5.getList('');
        });
      });
    },
    onchangeShowBusinessLockDividend: function onchangeShowBusinessLockDividend(row) {
      var _this6 = this;
      if (this.tableFrom.isSwitch === '0') return;
      row.showBusinessLockDividend = !row.showBusinessLockDividend;
      var title = !row.showBusinessLockDividend ? '是否开启商务锁仓分红字段显示' : '是否关闭商务锁仓分红字段显示';
      this.$modalSure(title).then(function () {
        merchant.merchantShowBusinessLockDividendSwitchApi(row.id).then(function () {
          row.showBusinessLockDividend = !row.showBusinessLockDividend;
          _this6.$message.success('切换商务锁仓分红显示开关成功');
          _this6.getList('');
        });
      });
    },
    /**
     *  开启关闭
     */
    onchangeIsClose: function onchangeIsClose(row) {
      var _this7 = this;
      !row.isSwitch ? merchant.merchantCloseApi(row.id).then(function () {
        _this7.$message.success('关闭成功');
        _this7.tableFrom.isSwitch = '1';
        _this7.getHeadNum();
        _this7.getList('');
      }) : merchant.merchantOpenApi(row.id).then(function () {
        _this7.$message.success('开启成功');
        _this7.tableFrom.isSwitch = '0';
        _this7.getHeadNum();
        _this7.getList('');
      });
    },
    getChange: function getChange() {
      this.getHeadNum();
      this.getList(1);
      this.closeModel();
    },
    closeModel: function closeModel() {
      this.dialogVisible = false;
    },
    /**
     *  添加
     */
    onAdd: function onAdd() {
      this.dialogVisible = true;
      this.isDisabled = false;
      this.indexKey = Math.random();
      this.merId = 0;
    },
    /**
     * 登录商户
     * @param id 商户id
     */
    handleLoginMer: function handleLoginMer(id) {
      (0, _user.merchantLogin)(id).then(function (res) {
        window.open("https://".concat(res.merSiteUrl, "/dashboard?token=").concat(res.token, "&account=").concat(res.account, "&isSms=").concat(res.isSms, "&leftSquareLogo=").concat(res.leftSquareLogo, "&leftTopLogo=").concat(res.leftTopLogo, "&realName=").concat(res.realName));
      });
    },
    /**
     *  编辑
     */
    handleEdit: function handleEdit(id, n, type) {
      this.dialogVisible = true;
      this.merId = id;
      this.indexKey = Math.random();
      this.handleType = type;
      n ? this.isDisabled = true : this.isDisabled = false;
    },
    /**
     *  修改手机号
     */
    handleUpdatePhone: function handleUpdatePhone(row, num) {
      this.merId = row.id;
      var _this = this;
      this.$modalParserFrom('修改商户手机号', '修改商户手机号', 1, {
        phone: row.phone
      }, function (formValue) {
        _this.submit(formValue, num);
      }, this.keyNum += 2);
    },
    /**
     *  设置复制次数
     */
    handleTimes: function handleTimes(row, num) {
      this.merId = row.id;
      var nums = row.copyProductNum;
      var _this = this;
      this.$modalParserFrom('修改复制商品数量', '修改复制商品数量', 1, {
        copyProductNum: nums || 0
      }, function (formValue) {
        _this.submit(formValue, num);
      }, this.keyNum += 1);
    },
    // 修改密码表单
    onPassword: function onPassword(id) {
      var _this8 = this;
      this.merId = id;
      this.$modalSure('重置商户密码为000000吗？').then(function () {
        merchant.merRsetPasswordApi(id).then(function (res) {
          _this8.$message.success('重置密码成功');
        });
      });
    },
    // 切换商户进件类型
    handleOnboardingTypeChange: function handleOnboardingTypeChange(row) {
      var _this9 = this;
      var newType = row.onboardingType === 2 ? 1 : 2;
      var typeName = newType === 2 ? '供货商进件商户' : '平台进件商户';
      this.$confirm("\u786E\u8BA4\u5C06\"".concat(row.name, "\"\u5207\u6362\u4E3A\u300C").concat(typeName, "\u300D\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        merchant.updateOnboardingTypeApi({
          id: row.id,
          onboardingType: newType
        }).then(function () {
          _this9.$message.success('切换成功');
          _this9.getList('');
        }).catch(function () {
          // 接口失败不修改本地值
        });
      }).catch(function () {});
    },
    submit: function submit(formValue, num) {
      var _this0 = this;
      if (num === 1) {
        var data = {
          id: this.merId,
          phone: formValue.phone
        };
        merchant.merchantupdatePhoneApi(data).then(function (res) {
          _this0.$message.success('操作成功');
          _this0.$msgbox.close();
          _this0.getList(1);
        }).catch(function () {
          _this0.loading = false;
        });
      } else {
        var _data = {
          id: this.merId,
          type: formValue.type,
          num: formValue.num
        };
        merchant.merchantCopyNumApi(_data).then(function (res) {
          _this0.$message.success('操作成功');
          _this0.$msgbox.close();
          _this0.getList(1);
        }).catch(function () {
          _this0.loading = false;
        });
      }
    }
  }
};